<main class="co-content clearfix row">
  <app-login-alert *ngIf="!isLoggedIn"></app-login-alert>
  <section class="co-content__left columns small-12">
    <app-address></app-address>
  </section>
</main>
